import { render } from "./FileDownload.vue?vue&type=template&id=fae416ca&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"

import "./FileDownload.vue?vue&type=style&index=0&id=fae416ca&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae416ca"]])

export default __exports__